/* eslint-disable no-case-declarations */
import { RedditOutlined } from '@ant-design/icons';
import { Avatar, Empty, List, Skeleton, Spin, Typography } from 'antd';
import dayjs from 'dayjs';
import { memo, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';
import ThongBaoService from 'src/services/ThongBao.service';
import { IThongBaoNhanVien } from 'src/types/ThongBao.type';
import CONTANTS from 'src/utils/constants';
import FUNCS from 'src/utils/func';

interface IProps {
  onClose: () => void;
  // newItem?: INotification;
  onDaXem: (daXem: number) => void;
}

interface IState {
  data: IThongBaoNhanVien[];
  loading: boolean;
  page: number;
  total: number;
}

const initState: IState = {
  data: [],
  loading: false,
  page: 1,
  total: 0,
};

const sv = new ThongBaoService();

function NotificationPopover(props: IProps) {
  const [state, setState] = useState<IState>(initState);
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (props.newItem) {
  //     setState((prev) => ({ ...prev, data: [props.newItem as INotification, ...prev.data] }));
  //   }
  // }, [props.newItem]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    if (state.loading) return;
    setState((prev) => ({ ...prev, loading: true }));
    try {
      const { data, total } = await sv.list({ take: CONTANTS.PAGE_SIZE, page: state.page });
      const soDaXem = data.reduce((sum, i) => (i.DaXem === 0 ? sum + 1 : sum), 0);
      soDaXem > 0 && props.onDaXem(soDaXem);
      setState((prev) => ({ ...prev, data, total }));
    } catch (error) {
      console.log(error);
    }
    setState((prev) => ({ ...prev, loading: false }));
  };

  const onLoadMore = async () => {
    try {
      const { data } = await sv.list({ take: CONTANTS.PAGE_SIZE, page: state.page });
      const soDaXem = data.reduce((sum, i) => (i.DaXem === 0 ? sum + 1 : sum), 0);
      soDaXem > 0 && props.onDaXem(soDaXem);
      setState((prev) => ({ ...prev, data: [...prev.data, ...data], page: prev.page + 1 }));
    } catch (error) {
      console.log(error);
    }
  };

  const onGoDetail = (item: IThongBaoNhanVien) => {
    if (!item.thongbao.Url) return;
    sv.docThongBao(item.id);
    navigate(item.thongbao.Url);

    props.onClose();
  };

  return (
    <div className="custom-popover-content" style={{ marginTop: -6 }}>
      <Spin spinning={state.loading}>
        <div
          id="notification"
          style={{
            height: 400,
            overflow: 'auto',
          }}
        >
          {state.data.length === 0 && <Empty />}
          {state.data.length > 0 && (
            <InfiniteScroll
              dataLength={state.data.length}
              next={onLoadMore}
              hasMore={state.data.length < state.total}
              loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
              scrollableTarget="notification"
            >
              <List
                dataSource={state.data}
                renderItem={(item) => (
                  <List.Item
                    key={item.id}
                    style={{ cursor: 'pointer' }}
                    onClick={() => onGoDetail(item)}
                    className="noti-list-item"
                  >
                    <List.Item.Meta
                      avatar={
                        !item.thongbao.nhanvien ? (
                          <Avatar size={48} icon={<RedditOutlined />} style={{ backgroundColor: 'black' }} />
                        ) : (
                          <Avatar size={48} src={FUNCS.getFullUrl(item.thongbao.nhanvien?.Avatar)} />
                        )
                      }
                      title={
                        <div>
                          <Typography.Text strong>{item.thongbao.TieuDe}</Typography.Text>{' '}
                          <Typography.Text style={{ fontWeight: 400, fontSize: 10 }} type="secondary">
                            {dayjs(item.thongbao.NgayTao).fromNow()}
                          </Typography.Text>
                        </div>
                      }
                      description={`${item.thongbao.NoiDung}`}
                    />
                    {!item.DaDoc && <div className="unseen-dot" />}
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          )}
        </div>
      </Spin>
    </div>
  );
}

export default memo(NotificationPopover);
